<template>
  <div class="spaigge-widget">
    <div class="wg-row icons">
      <div
        v-for="(c, i) in components"
        :key="'comp-' + i"
        :class="c.id"
        :title="c.title"
        @click="openDialog(c)"
      >
        <img
          class="com-anm22-app-img-fixed-height-l"
          style="padding: 5px; height: 100%"
          :src="$anm22.icons.getWorldIcon(c.icon)"
        />
      </div>
    </div>
    <wg-modal
      :width="windowWidth > 700 ? '600px' : '90%'"
      v-if="showModal"
      @closeModal="closeDialog"
      :portal="true"
    >
      <div slot="header" class="com-anm22-app-text-xl">{{ dialogTitle }}</div>
      <component
        slot="body"
        :is="selectedCustomComponent"
        :projectId="project.idWorldProject"
        :contact="customer"
      ></component>
    </wg-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String]
  },
  data() {
    return {
      docs: {},
      showModal: false,
      selectedCustomComponent: "",
      dialogTitle: ""
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    customer() {
      if (this.project.customers.length > 0) {
        return this.$store.getters["contacts/get"](this.project.customers[0]);
      } else {
        return null;
      }
    },
    components() {
      let components = [];
      // YourBeach
      if(this.customer) {
        if(this.project.category == 7) {
          if (!this.customer.otherInformations || !this.customer.otherInformations["yb-license"]) {
            components.push({
              id: "yb-license",
              title: this.$anm22.strLang(
                this.lang,
                "Generate YourBeach license",
                "Genera licenza YourBeach"
              ),
              component: "YourBeachCreate",
              icon: "umbrellaAdd"
            });
          }
        }
        // YourFood
        if(this.project.category == 8) {
          if (!this.customer.otherInformations || !this.customer.otherInformations["yf-license"]) {
            components.push({
              id: "yf-license",
              title: this.$anm22.strLang(
                this.lang,
                "Generate YourFood license",
                "Genera licenza YourFood"
              ),
              component: "YourFoodCreate",
              icon: "foodAdd"
            });
          }
        }
      }
      return components;
    }
  },
  methods: {
    openDialog(obj) {
      this.dialogTitle = obj.title;
      this.selectedCustomComponent = obj.component;
      this.showModal = true;
    },
    closeDialog() {
      this.showModal = false;
    }
  },
  async created() {},
  components: {
    YourBeachCreate: () => import(/* webpackChunkName: "custom-6" */ "./YourBeachCreate.vue"),
    YourFoodCreate: () => import(/* webpackChunkName: "custom-6" */ "./YourFoodCreate.vue")
  }
};
</script>

<style lang="scss" scoped>
.spaigge-widget .icons {
  align-items: center;
  font-size: 0;
  padding: 5px 0 0 0;
  flex-wrap: nowrap;
}
.spaigge-widget .icons div {
  border-radius: 30px;
  width: 60px;
  height: 60px;
  background-color: #ddd;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 10px;
  margin: 5px 10px;
  cursor: pointer;

  &:hover {
    background-color: #ccc;
  }
}
</style>

